import * as React from 'react';
import { Button } from 'react-bootstrap';
import { inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import Callout from '../site/Callout';

interface IVorgangStatusProps {
  auftragId: string;
  vorgangId: string;
  status: string;
  caption: string;
  text: string;
  buttonCaption: string;
  bsStyle?: 'success' | 'info' | 'danger' | 'warning' | 'default';
}

export default class VorgangStatus extends React.Component<IVorgangStatusProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  async setzeStatus() {
    // Nur bestimmte Status erlauben
    switch (this.props.status) {
      case 'abgeschl': {
          const response = await this.apiStore.vorgangAbschliessen(this.props.vorgangId);
          if (response.ok) {
            this.uiStore.navigateTo(`/auftrag/${this.props.auftragId}`);
          }
          break;
      }
      default:
        throw new Error('Ungültiger Status');
    }
  }

  render() {
    let { bsStyle, caption, text, buttonCaption } = this.props;
    return (
      <Callout bsStyle={bsStyle}>
        <h4>{caption}</h4>
        <p>{text}</p>
          <div className="text-right">
            <Button bsStyle={bsStyle} type="submit" onClick={() => this.setzeStatus()}>{buttonCaption}</Button>
          </div>
      </Callout>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorgangStatus.tsx